import { useButton } from '@react-aria/button';
import { useFocusVisible } from '@react-aria/interactions';
import useMergedRef from '@react-hook/merged-ref';
import React, { useRef } from 'react';
import { useExternalLink, useTheme } from '../../hooks/index.js';
import { Text } from '../text/index.js';
import { ButtonElement, ClipSpan, LoadingIcon } from './button.styles.js';
export const Button = React.forwardRef(({ elementType, href, isDisabled, onPress, onPressStart, rel, target, isPressed, variant = 'primary', isFrozen, startIcon, endIcon, children, loading, fullWidth, excludeFromTabOrder, preventFocusOnPress, fontSize, isAriaDisabled, ...rest }, forwardedRef) => {
    const { styles } = useTheme();
    const buttonRef = useRef(null);
    const ref = useMergedRef(forwardedRef, buttonRef);
    const externalLinkProps = useExternalLink({ href, target, rel });
    const { isFocusVisible } = useFocusVisible();
    const { buttonProps } = useButton({
        ...rest,
        children,
        isDisabled,
        elementType,
        excludeFromTabOrder,
        ...(!isAriaDisabled && { onPress, onPressStart }),
        ...(isPressed && { 'aria-pressed': true }),
        preventFocusOnPress,
    }, buttonRef);
    return (React.createElement(ButtonElement, { ref: ref, startIcon: startIcon, endIcon: endIcon, hasChildren: !!React.Children.count(children), as: elementType, ...rest, ...buttonProps, ...externalLinkProps, variant: variant, href: href, loading: loading, fullWidth: fullWidth, isFocusVisible: isFocusVisible, isAriaDisabled: isAriaDisabled, ...((isFrozen || loading || isAriaDisabled) && {
            'aria-disabled': true,
        }) },
        loading === 'spinner' && React.createElement(LoadingIcon, { variant: variant }),
        React.createElement(Text, { loading: loading === 'skeleton' ? true : undefined, color: 'inherit', startIcon: startIcon, endIcon: endIcon, lineHeight: styles.uiText.control.lineHeight, loadingColor: styles.buttons.variant[variant].inactive.skeletonColor, fontSize: fontSize }, endIcon && children ? React.createElement(ClipSpan, null, children) : children)));
});
//# sourceMappingURL=button.component.js.map